const formatPrice = (price = 0) => {
  const finalPrice = Number(price)
  if (isNaN(finalPrice)) return "N/A"
  return price.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  })
}

export default formatPrice
